module.exports = __webpack_public_path__ + "static/img/452.d755805f.png";